import {showDeleteConfirmation} from '@modules/common';
import {switchMap} from 'rxjs/operators';
import {BaseBloc} from '@core/utils/bloc';
import {Repository} from '@core/utils/repository';
import {handleMessage, requestMessage} from '@business/messages';
import {EstimateGroupId, GroupNoteId, TimeMaterialGroupNotesResponse} from "@business/entities/tm";
import {TmGroupNotesAPI} from "@business/api/tm_group_notes";

export class TMGroupNotesBloc extends BaseBloc {
    private readonly tmGroupNotesRepo = new Repository<TimeMaterialGroupNotesResponse>({
        getItemId: item => item.id,
    });

    readonly notes$ = this.tmGroupNotesRepo.items$;

    onReset() {
        this.tmGroupNotesRepo.reset();
    }

    fetchGroupNotes = (groupId: EstimateGroupId) => {
        return TmGroupNotesAPI.fetchGroupNotes(groupId).pipe(
            this.tmGroupNotesRepo.ops.reset(),
            handleMessage({error: requestMessage('fetch_tm_order_estimate_group_notes_error')}),
        );
    };

    createGroupNote = (groupId: EstimateGroupId, note: string) => {
        return TmGroupNotesAPI.createGroupNote(groupId, note).pipe(
            this.tmGroupNotesRepo.ops.addOne(item => item),
            handleMessage({
                type: requestMessage('create_tm_order_estimate_group_note'),
            }),
        );
    };

    updateGroupNote = (noteId: GroupNoteId, note: string) => {
        return TmGroupNotesAPI.updateGroupNote(noteId, note).pipe(
            this.tmGroupNotesRepo.ops.upsertOne(item => ({item})),
            handleMessage({
                type: requestMessage('update_tm_order_estimate_group_note'),
            }),
        );
    };

    deleteGroupNote = (noteId: GroupNoteId) => {
        return showDeleteConfirmation('Delete Note', 'Do you really want to remove this note?').pipe(
            switchMap(() => TmGroupNotesAPI.deleteGroupNote(noteId)),
            this.tmGroupNotesRepo.ops.removeOne(() => noteId),
            handleMessage({
                type: requestMessage('delete_tm_order_estimate_group_note'),
            }),
        );
    };
}
